import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})

export class HubspotService {

  http = inject(HttpClient);

  getBlog() {
    // 'https://blog.softprocorp.com/_hcms/postlisting?blogId=4627073599&maxLinks=3&listingType=recent&orderByViews=false&hs-expires=1758898920&hs-version=2&hs-signature=AJ2IBuGeWz-RkCKdyRTZimzzCL417wCYfA&currentUrl=https%3A%2F%2Fblog.softprocorp.com%2F'
    return this.http.get<any>(`${environment.apiUrl}/hubspot`)
      .pipe(map((res) => {
        return res;
      }));
  }

  // Private App Token: pat-na1-472294f5-8753-4fa8-b568-b1372434b897
  // You can also find this access token on the Private apps homepage and the mysoftpro-blog app auth page.

}
